import { render, staticRenderFns } from "./DetailReturnMedicalRecord.vue?vue&type=template&id=43a3f914"
import script from "./DetailReturnMedicalRecord.vue?vue&type=script&lang=js"
export * from "./DetailReturnMedicalRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports